import SelectOption from './selectOption';

const temperatureConfList = (): SelectOption[] => [
    { value: 'Celsius', label: `Celsius` },
    { value: 'Fahrenheit', label: `Fahrenheit` }
];

export default temperatureConfList;
